import { render, staticRenderFns } from "./screw-detail.vue?vue&type=template&id=bb69b8c4&"
import script from "./screw-detail.vue?vue&type=script&lang=js&"
export * from "./screw-detail.vue?vue&type=script&lang=js&"
import style0 from "./screw-detail.vue?vue&type=style&index=0&id=bb69b8c4&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports